var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"success",attrs:{"dark":""},on:{"click":_vm.setShowDialog}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-account-plus")])],1)]}}])},[_c('span',[_vm._v("Cadastro de Pessoas")])])
}
var staticRenderFns = []

export { render, staticRenderFns }